import { ReplaySubject ,  Observable } from 'rxjs';

export class DataStore<T> {
  private subject: ReplaySubject<T>;
  private state: T;

  constructor() {
    this.subject = new ReplaySubject(1);
  }

  public getData(): Observable<T> {
    return this.subject.asObservable();
  }

  public setData(nextState: T): void {
    this.state = nextState;

    this.subject.next(nextState);
  }

  protected getValue(): T {
    return this.state;
  }
}
